import React, { useEffect, useState } from "react";
import BookmarkIcon from "../../assets/icons/BookmarkIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";
import SearchIcon from "../../assets/icons/SearchIcon";
import Checkbox from "../../common/Checkbox";
import KebabIcon from "../../assets/icons/kebabmenu.png";
import { Circles } from "react-loader-spinner";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box,
  Menu,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { updateAppointment } from "../../services/appointment";
import {
  getCurrentCompleteDate,
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  getUserIdFromLocalStorage,
} from "../../utils/Utilities";

import "./index.scss";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";
import CasesDropdownMenu from "../cases/CasesDropdown";
import { usePermission } from "../../hooks/permission/usePermission";
import { MANAGE_APPOINTMENTS } from "./../../constants/permissionKeys";
import FormattedDate from "./../../utils/TabelDateFormat";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
    },
  },
}));

const AppointmentList = ({
  data,
  handleRefresh,
  search,
  handleSearch,
  searchFilterState,
  handleFilterStateActive,
  entireCasesText,
  handleEntireCasesText,
  handleSetConsultantFilter,
  selectedConsultant,
  consultantsList,
}) => {
  let uID = getUserIdFromLocalStorage();
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { checkPermission } = usePermission();
  const permissionManageAppointments = checkPermission(MANAGE_APPOINTMENTS);
  const [list, setList] = useState([]);
  const [openConsultantFilter, setOpenConsultantFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterByMarked, setFilterByMarked] = useState(false);
  const [filterByDelete, setFilterByDelete] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);

  const open = Boolean(anchorEl);
  const handleClickContact = (event, id) => {
    setOpenMenuId(id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    let tempData = [];
    if (!filterByDelete && !filterByMarked) {
      tempData = data.map((item) => ({ ...item, isChecked: false } || []));
    } else if (filterByDelete && !filterByMarked) {
      tempData =
        data
          .map((item) => ({ ...item, isChecked: false }))
          .filter((ele) => ele.isDeleted) || [];
    } else if (!filterByDelete && filterByMarked) {
      tempData =
        data
          .map((item) => ({ ...item, isChecked: false }))
          .filter((ele) => ele.isMarked) || [];
    } else {
      tempData =
        data
          .map((item) => ({ ...item, isChecked: false }))
          .filter((ele) => ele.isMarked || ele.isDeleted) || [];
    }
    setList(tempData);
  }, [data, filterByMarked, filterByDelete]);
  const handleChangeCheck = (e) => {
    setList(
      list.map((item) => {
        if (item.appointmentId == e.target.id)
          return { ...item, isChecked: !item.isChecked };
        return item;
      })
    );
  };
  const handleClickName = (id, caseId) => {
    navigate(`/appointments/${id}/family-tree`);
    localStorage.setItem("caseId", caseId);
  };
  const handleUpdateList = async (payload) => {
    const result = await updateAppointment(payload, uID);
    if (result?.success) {
      handleRefresh();
    }
  };

  const handleClickBookmark = (ele) => {
    setList(
      list.map((item) => {
        if (item.appointmentId == ele.appointmentId)
          return { ...item, isMarked: !item.isMarked };
        return item;
      })
    );
  };
  const handleDelete = async () => {
    await handleUpdateList(
      list
        .filter((item) => item.isChecked)
        .map((ele) => ({ ...ele, isDeleted: true }))
    );
  };
  const handleCloseDropdown = () => {
    setOpenConsultantFilter(false);
  };
  return (
    <>
      <div className="cases">
        <div className="input-wrapper">
          <input
            value={search}
            placeholder={t(getKeyFromText("Name, Surname, date of birth"))}
            className="custom-input"
            onChange={(e) => {
              handleSearch(e.target.value);
            }}
          />
          <SearchIcon
            className="search-icon"
            onClick={() => {
              handleRefresh();
              handleFilterStateActive();
            }}
          />
        </div>
        <div style={{ position: "relative" }}>
          <button
            type="button"
            className="filter-btn"
            disabled={searchFilterState}
            onClick={() => {
              setOpenConsultantFilter((pre) => !pre);
            }}
          >
            {searchFilterState ? (
              <CircularProgress size={32} color="inherit" />
            ) : (
              "Filter"
            )}
          </button>
          {openConsultantFilter && (
            <CasesDropdownMenu
              handleSubmit={(value) => {
                handleSetConsultantFilter(value);
                handleCloseDropdown();
                handleRefresh();
              }}
              handleClose={handleCloseDropdown}
              list={consultantsList}
              selectedValue={selectedConsultant}
            />
          )}
        </div>
        <h5
          onClick={() => {
            handleSearch("");
            handleRefresh();
            handleEntireCasesText();
            handleSetConsultantFilter();
          }}
          style={{
            pointerEvents: entireCasesText ? "all" : "none",
            cursor: "pointer",
          }}
        >
          {entireCasesText ? "Entire cases" : ""}
        </h5>
      </div>
      <div
        className="cases-table"
        style={{
          minHeight: "500px",
          overflow: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: loading && "center",
        }}
      >
        {loading ? (
          <Circles color="#dfc8db" height={80} width={80} />
        ) : (
          <TableContainer component={Paper}>
            <Box sx={{ display: "flex" }}>
              <DeleteIcon
                style={{
                  width: "25px",
                  margin: "10px",
                  opacity: list.every((item) => !item.isChecked) ? "0.6" : "1",
                  cursor: list.every((item) => !item.isChecked)
                    ? "default"
                    : "pointer",
                  pointerEvents: list.every((item) => !item.isChecked)
                    ? "none"
                    : "all",
                }}
                onClick={handleDelete}
              />
              <Box
                component="div"
                sx={{
                  display: "flex",
                  justifyCotent: "center",
                  alignItems: "center",
                  fontWeight: "400",
                  marginRight: "30px",
                  cursor: "pointer",
                  opacity: filterByMarked ? 1 : 0.6,
                }}
                onClick={() => {
                  setFilterByMarked((pre) => !pre);
                }}
              >
                <BookmarkIcon
                  style={{
                    width: "20px",
                    display: "flex",
                    alignItems: "center",
                    fill: filterByMarked ? "#FFD76C" : "none",
                    cursor: "pointer",
                  }}
                  color={filterByMarked ? "#FFD76C" : "#A3A3A3"}
                />
                {t(getKeyFromText("Marked report"))}
              </Box>
              <Box
                component="div"
                sx={{
                  display: "flex",
                  justifyCotent: "center",
                  alignItems: "center",
                  fontWeight: "400",
                  cursor: "pointer",
                  opacity: filterByDelete ? 1 : 0.6,
                }}
                onClick={() => {
                  setFilterByDelete((pre) => !pre);
                }}
              >
                <DeleteIcon
                  type={"filled"}
                  style={{
                    width: "20px",
                    fill: "black",
                    cursor: "pointer",
                  }}
                />
                {t(getKeyFromText("Deleted report"))}
              </Box>
            </Box>
            <Table
              sx={{
                minWidth: 650,

                maxHeight: "300px",
                overflow: "auto",
                "th , td": { border: "none", padding: "8px 16px" },
                th: {
                  padding: "10px 16px",
                  borderBottom: "1px solid #DEDEDE",
                  borderTop: "1px solid #DEDEDE",
                },
              }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "50px" }} align="right"></TableCell>
                  <TableCell sx={{ width: "40px" }}></TableCell>
                  <TableCell sx={{}}>{t(getKeyFromText("Branch"))}</TableCell>
                  <TableCell>{t(getKeyFromText("Name"))}</TableCell>
                  <TableCell>{t(getKeyFromText("Date of birth"))}</TableCell>
                  <TableCell>{t(getKeyFromText("req-time"))}</TableCell>

                  <TableCell> {t(getKeyFromText("Contact"))}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item) => {
                  return (
                    <TableRow key={item.appointmentId}>
                      <TableCell align="right">
                        <div
                          style={{
                            marginTop: "-8px",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            display: permissionManageAppointments
                              ? "block"
                              : "none",
                          }}
                        >
                          <Checkbox
                            id={item.appointmentId}
                            checked={item.isChecked}
                            onChange={handleChangeCheck}
                            theme={item.isChecked ? "checked" : "secondary"}
                          />
                        </div>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            justifyCotent: "center",
                            alignItems: "center",
                            fontWeight: "400",
                          }}
                        >
                          <BookmarkIcon
                            style={{
                              width: "20px",
                              display: "flex",
                              alignItems: "center",
                              fill: item.isMarked ? "#FFD76C" : "none",
                              cursor: permissionManageAppointments
                                ? "pointer"
                                : "",
                            }}
                            color={item.isMarked ? "#FFD76C" : "#A3A3A3"}
                            onClick={() => {
                              permissionManageAppointments
                                ? (handleClickBookmark(item),
                                  handleUpdateList([
                                    { ...item, isMarked: !item.isMarked },
                                  ]))
                                : null;
                            }}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>{item?.branchName || ""}</TableCell>
                      <TableCell
                        sx={{
                          cursor: permissionManageAppointments ? "pointer" : "",
                        }}
                        onClick={() =>
                          permissionManageAppointments
                            ? handleClickName(item.clientId, item.caseId)
                            : null
                        }
                        align="left"
                      >
                        {item?.clientName || ""}
                      </TableCell>
                      <TableCell>
                        {/* {item?.clientDOB?.slice(0, 10) || ""} */}
                        <FormattedDate
                          date={item?.clientDOB}
                          language={i18n.language}
                        />
                      </TableCell>
                      <TableCell>
                        <FormattedDate
                          date={item?.clientRequestTime}
                          language={i18n.language}
                        />
                        {/* {getCurrentCompleteDate() ===
                        getDateFromDateStamp(item?.clientRequestTime)
                          ? getTimeFromDateStamp(item?.clientRequestTime)
                          : getDateFromDateStamp(item?.clientRequestTime) || ""} */}
                      </TableCell>

                      <TableCell>
                        <Box
                          component={"div"}
                          onClick={(event) =>
                            handleClickContact(event, item.appointmentId)
                          }
                          sx={{ cursor: "pointer" }}
                        >
                          <Box
                            component={"img"}
                            sx={{ height: "20px", cursor: "pointer" }}
                            src={KebabIcon}
                            id="basic-button"
                            aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                          />
                        </Box>
                        <StyledMenu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          // open={open}
                          open={open && openMenuId === item.appointmentId}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                          sx={{
                            boxShadow:
                              "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                          }}
                        >
                          <MenuItem
                            sx={{
                              "&:hover": {
                                backgroundColor: "white",
                                cursor: "default",
                              },
                            }}
                            onClick={handleClose}
                          >
                            <img
                              src={require("../../assets/images/email.png")}
                              alt="email"
                              style={{ marginRight: "10px" }}
                            />
                            {item?.clientEmail || ""}
                          </MenuItem>
                          <MenuItem
                            sx={{
                              "&:hover": {
                                backgroundColor: "white",
                                cursor: "default",
                              },
                            }}
                            onClick={handleClose}
                          >
                            <img
                              src={require("../../assets/images/call.png")}
                              alt="email"
                              style={{ marginRight: "10px" }}
                            />
                            {item?.clientPhone || ""}
                          </MenuItem>
                        </StyledMenu>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </>
  );
};

export default AppointmentList;
